import { render, staticRenderFns } from "./sjh_report.vue?vue&type=template&id=b6806d2c&scoped=true"
import script from "./sjh_report.vue?vue&type=script&lang=js"
export * from "./sjh_report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6806d2c",
  null
  
)

export default component.exports